import React from "react";

import * as S from "./styles";

import IBaseProps from "../base-modal/props";
import Modal from "../base-modal";
import { theme } from "../../../styles/theme";

type IProps = {
  text: string;
  onConfirm: () => void;
  onCancel: () => void;
} & Omit<IBaseProps, "content">;

const ChooseModal: React.FC<IProps> = ({
  text,
  onConfirm,
  onCancel,
  ...rest
}) => (
  <Modal
    {...rest}
    styles={{
      backgroundColor: theme.colors.darkBlue,
    }}
    content={{
      title: text,
      component: () => (
        <S.Container>
          <S.Title>Corfirmação:</S.Title>
          <S.Text>{text}</S.Text>
          <S.ButtonsContainer>
            <S.Button onClick={onConfirm} color="blue400">
              Sim
            </S.Button>
            <S.Button onClick={onCancel} color="erro">
              Não
            </S.Button>
          </S.ButtonsContainer>
        </S.Container>
      ),
    }}
  />
);

export default ChooseModal;
